// extracted by mini-css-extract-plugin
export default {"WelcomeSecionFrame":"WelcomePageFromSignIn_WelcomeSecionFrame__x1Wqr"};